export default class ConfigService {

	static configSelector = '#js-config';
	static config = null;

	static getConfig(name) {
		if (ConfigService.config === null) {
			ConfigService.config = JSON.parse(document.querySelector(ConfigService.configSelector).textContent);
		}

		if (typeof name === 'undefined') {
			return ConfigService.config;
		}

		return ConfigService.config[name];
	}

}